import React from 'react';
import { Table, Input } from 'antd';
import { get as ObjectGetter } from 'lodash';

export function AntTable({ headers, data, options = {} }) {
    const { search } = options;
    // const { width, apiEnabled, columns, onSearch, enabled, onClear } = search;
    return (
        <>
            {search?.enabled && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }} className="mb-3">
                <Input.Search
                    placeholder={"Search"}
                    style={{
                        width: search.width || "20%"
                    }}
                    onSearch={(searchTerm) => {
                        if (searchTerm) {
                            if (search.apiEnabled) {
                                search.onSearch(searchTerm, search.columns)
                            } else {
                                const filteredData = data.filter(record =>
                                    search.columns.some(term => {
                                        return String(ObjectGetter(record, term))
                                            .toLowerCase()
                                            .includes(searchTerm.toLowerCase())
                                    })
                                );
                                search.onSearch(filteredData)
                            }
                        }
                    }}
                    allowClear
                    onChange={(e) => {
                        if (e.target.value === "") {
                            search.onClear();
                        }
                    }}
                />
                {search.searchExtra}
              </div>
            )}
            <Table columns={headers} dataSource={data} {...options} />
        </>
    )
}